import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/website/mercari/`;

const getDashboardItems = async (shop) => {
  return await axios.get(API_URL + "admin/dashboard", { params: { shop } });
};

const takeNewPriceNegotiationCase = async (formData) => {
  return await axios.post(API_URL + "admin/price-negotiation/take", formData);
};

const completePriceNegotiationCase = async (formData) => {
  return await axios.post(API_URL + "admin/price-negotiation/complete", formData);
};

// `source` ('paypay') routes the SAME endpoint to the shared negotiation table on
// the backend; omitted → the Mercari table, exactly as before.
const releasePriceNegotiationCase = async (negotiationId, source = null) => {
  return await axios.post(API_URL + "admin/price-negotiation/release", { negotiationId, ...(source ? { source } : {}) });
};

const takeNewPurchaseCase = async (formData) => {
  return await axios.post(API_URL + "purchase/take", formData);
};

const completePurchaseCase = async (formData) => {
  return await axios.post(API_URL + "purchase/complete", formData);
};

const releasePurchaseCase = async (purchaseId, source = null) => {
  // Custom-link tasks ride the same endpoint, tagged source:'customlink' so the
  // backend releases the right caseType (mercari purchases send no source).
  return await axios.post(API_URL + "purchase/release", { purchaseId, ...(source ? { source } : {}) });
};

// ส่งตรวจ (Anshin appraisal). A case appears once the parcel has reached the
// inspection centre and enough days have passed for a result to exist; the admin
// takes it, opens Mercari, and either records the outcome or says "not yet".
// Its own route group — an appraisal is a different task from buying an item.
// Called from /addtracking, not the board: the seller has shipped to the
// inspection centre. Multipart, because it carries up to two screenshots proving
// the number is the one the seller entered — the same proof, and the same bypass,
// as an ordinary Mercari tracking number.
const markAppraisalSent = async ({ orderId, trackingJp, images = [], notMercariBypass = false }) => {
  const formData = new FormData();
  formData.append('orderId', orderId);
  formData.append('trackingJp', trackingJp);
  if (notMercariBypass) formData.append('notMercariBypass', 'true');
  images.forEach((file) => formData.append('appraisalImage', file));
  return await axios.post(API_URL + "admin/appraisal/sent", formData);
};

const takeAppraisalCase = async (formData) => {
  return await axios.post(API_URL + "admin/appraisal/take", formData);
};

const releaseAppraisalCase = async (orderId) => {
  return await axios.post(API_URL + "admin/appraisal/release", { orderId });
};

const recordAppraisalResult = async ({ orderId, result, note }) => {
  return await axios.post(API_URL + "admin/appraisal/result", { orderId, result, note });
};

// What "ไม่ผ่าน" would do before it is done: whether the money goes back by
// itself and exactly how much. Read-only, and it asks the same question the
// action asks — so the confirmation cannot promise one thing and the button do
// another.
const previewAppraisalFailure = async (orderId) => {
  return await axios.post(API_URL + "admin/appraisal/failure-preview", { orderId });
};

// "ยังไม่เสร็จ" — no result on Mercari yet. Steps the case off the board for a
// day and hands the claim back, so tomorrow anyone can pick it up.
const deferAppraisalCheck = async (orderId) => {
  return await axios.post(API_URL + "admin/appraisal/defer", { orderId });
};

// Re-find guest +Δ reconcile payment links (the confirm result dialog shows the link once).
// status: 'pending' (default) | 'completed' | 'cancelled' | 'all'.
const getReconcileCollections = async (shop, status = "pending") => {
  return await axios.get(API_URL + "admin/reconcile-collections", { params: { shop, status } });
};

export default {
  getDashboardItems,
  takeNewPriceNegotiationCase,
  completePriceNegotiationCase,
  releasePriceNegotiationCase,
  takeNewPurchaseCase,
  completePurchaseCase,
  releasePurchaseCase,
  markAppraisalSent,
  takeAppraisalCase,
  releaseAppraisalCase,
  recordAppraisalResult,
  previewAppraisalFailure,
  deferAppraisalCheck,
  getReconcileCollections
};
